import TopicKeyWords from './TopicKeyWords';

export default TopicKeyWords;
